// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2374":"5c4894ce46c5dbb2","2676":"7bc980dcd8a18a5b","3877":"fe336940f98fdfab","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};